import React from 'react'
import '../App.css'
import Bodyticket from './bodyticket'
export class Bodyappticketbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodyticket/>
            </div>
        
        );
    }
}